module.exports = __webpack_public_path__ + "static/media/research-evolve.9af37fc2.png";